import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AllocateClusterOccupantPayrolls(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $employeeId: ID!
    $payrollIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                allocateClusterOccupantPayrolls(
                  clusterId: $clusterId
                  employeeId: $employeeId
                  payrollIds: $payrollIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AllocateClusterOccupantPayrollsMutation,
  undefined,
  graphql.schema.AllocateClusterOccupantPayrollsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
